module.exports = __webpack_public_path__ + "static/media/wax-bath.78c8fa12.png";